import FondationsServiceModel   from '@/models/FondationsServiceModel';
import { computed }             from 'mobx';

export default class UserMeModel extends FondationsServiceModel {
	static get path(): string {
		return '/users/me';
	}

	get userMediaProfilePicture() {
		return this.get('userMediaProfilePicture.objectUrl');
	}

	get email() {
		return this.get('email', '');
	}

	get firstName() {
		return this.get('firstName', '');
	}

	get lastName() {
		return this.get('lastName', '');
	}

	@computed
	get fullName() {
		return this.get('firstName', '') + ' ' + this.get('lastName', '');
	}

	get gender() {
		return this.get('gender', 1);
	}

	@computed
	get fullNameFirstLetters() {
		let wbcPictureEmptyText = '';
		wbcPictureEmptyText += this.get('firstName') ? this.get('firstName')[0] : '';
		wbcPictureEmptyText += this.get('lastName') ? this.get('lastName')[0] : '';
		return wbcPictureEmptyText;
	}

	public patch(attributes?: Record<string, unknown>, options?: ConnectorSaveOptions): Promise<this> {
		return super.patch(attributes, { 
			...options,
			path: `users/${this.id}/me`
		})
	}
}
